import React from 'react';
// Custom thin line art SVG icons for R.I.S.E.
const iconProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '1.2',
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  className: 'w-12 h-12'
};
export function EyeIcon() {
  return <svg {...iconProps} data-id="element-269">
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" data-id="element-270" />
      <circle cx="12" cy="12" r="3" data-id="element-271" />
    </svg>;
}
export function FingerprintIcon() {
  return <svg {...iconProps} data-id="element-272">
      <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4" data-id="element-273" />
      <path d="M14 13.12c0 2.38 0 6.38-1 8.88" data-id="element-274" />
      <path d="M17.29 21.02c.12-.6.43-2.3.5-3.02" data-id="element-275" />
      <path d="M2 12a10 10 0 0 1 18-6" data-id="element-276" />
      <path d="M2 16h.01" data-id="element-277" />
      <path d="M21.8 16c.2-2 .131-5.354 0-6" data-id="element-278" />
      <path d="M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2" data-id="element-279" />
      <path d="M8.65 22c.21-.66.45-1.32.57-2" data-id="element-280" />
      <path d="M9 6.8a6 6 0 0 1 9 5.2v2" data-id="element-281" />
    </svg>;
}
export function AnchorIcon() {
  return <svg {...iconProps} data-id="element-282">
      <circle cx="12" cy="5" r="3" data-id="element-283" />
      <line x1="12" y1="22" x2="12" y2="8" data-id="element-284" />
      <path d="M5 12H2a10 10 0 0 0 20 0h-3" data-id="element-285" />
    </svg>;
}
export function TrendingUpIcon() {
  return <svg {...iconProps} data-id="element-286">
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" data-id="element-287" />
      <polyline points="16 7 22 7 22 13" data-id="element-288" />
    </svg>;
}